import axios from "axios";
import { pushToast } from "../utils/pushToast";
var changeForcePassword = false
const apiUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_KEY : process.env.REACT_APP_DEV_API_KEY;

const client = axios.create({
    baseURL: apiUrl,
})

client.defaults.headers.common.Accept = 'application/json';
client.defaults.headers.common['charset'] = 'utf8';
client.defaults.headers.common['Accept-Language'] = "fa";
client.defaults.headers.common['Content-Type'] = 'application/json';
client.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
client.interceptors.request.use(request => {
    if (changeForcePassword === false || request.url === 'User/ChangeUserPasswordByUser' || 'Authentication/Logout' || 'Authentication/LoginUser')
        return request;
    else
        window.location.replace("/change-password")

})

client.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status === 401) {
        removeToken();
        window.location.replace("/login")
    }
    if (error.response.status === 403) {
        pushToast("خطای دسترسی", "error")
    }
    return Promise.reject(error)
})

export const setToken = (token) => {
    localStorage.setItem('token', token);
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const removeToken = () => {
    localStorage.removeItem('token');
    client.defaults.headers.common['Authorization'] = "";
}

export const login = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const { data } = await client.post(`Authentication/LoginUserWithMobile`, values);
    return data;
}

export const loginWithPassword = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const { data } = await client.post(`Authentication/LoginUser`, values);
    return data;
}

export const checkOtpCode = async (values) => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) throw new Error('OTP session is missing');

    const { data } = await client.post(`Authentication/CheckOtpCode`, {...values, authToken});
    return data;
}

export const me = async () => {
    const { data } = await client.post(`User/UserInfo`);

    if (data.userInfo.data.requiredChangePassword === true) {
        changeForcePassword = true
    }
    return data;
}

export const logout = async (values) => {
    const { data } = await client.post(`Authentication/Logout`, values);
    removeToken();
    return data;
}

export const register = (values) => {
    const { data } = client.post(`Authentication/RegisterUser`, values);
    setToken(data.token);
    return data;
}

export const forgetPassword = (values) => {
    const { data } = client.post(`forget-password`, values);
    return data;
}

export const resetPassword = (values) => {
    const { data } = client.post(`Authentication/resetPassword`, values);
    return data;
}

export const verifyEmail = () => {
    const { data } = client.get(`verify-email`);
    return data;
}

export const ChangeUserPasswordByUser = async (values) => {
    const { data } = await client.post(`User/ChangeUserPasswordByUser`, values);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}

export const ChangeUserPassword = async (id) => {
    const { data } = await client.get(`User/ChangeUserPassword/${id}`);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}
export const ChangeActiveStatus = async (id) => {
    const { data } = await client.get(`User/ChangeActiveStatus/${id}`);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}
// common

export const languages = async () => {
    const { data } = await client.get(`Common/GetListLanguage`);
    return data;
}

// User
export const users = async (values) => {
    const { data } = await client.post(`User/UserList`, values);
    return data;
}

export const user = async (id) => {
    const { data } = await client.get(`User/UserItem/${id}`);
    return data;
}
export const GetUserFullName = async (id) => {
    const { data } = await client.get(`User/GetUserFullName/${id}`);
    return data;
}
export const createUser = async (values) => {
    const { data } = await client.post(`User/AddNewUser`, values)
    return data;
}

export const updateUser = async (id, values) => {
    const { data } = await client.patch(`User/EditUser/${id}`, values)
    return data;
}
export const uploadExcelFile = async (values) => {
    const { data } = await client.post(`User/UploadExcelFile`, values)
    return data;
}
export const deleteUser = async (id) => {
    const { data } = await client.delete(`User/RemoveUser/${id}`)
    return data;
}

export const updateUserRole = async (values) => {
    const { data } = await client.patch(`User/UpdateUserRole`, values)
    return data;
}

// permission category

export const permissionCategories = async (values) => {
    const { data } = await client.post(`PermissionCategory/PermissionCategoryList`, values);
    return data;
}

export const permissionCategory = async (id) => {
    const { data } = await client.get(`PermissionCategory/PermissionCategoryItem/${id}`);
    return data;
}

export const createPermissionCategory = async (values) => {
    const { data } = await client.post(`PermissionCategory/AddPermissionCategory`, values);
    return data;
}

export const deletePermissionCategory = async (id) => {
    const { data } = await client.delete(`PermissionCategory/RemovePermissionCategory/${id}`);
    return data;
}

export const updatePermissionCategory = async (id, values) => {
    const { data } = await client.patch(`PermissionCategory/EditPermissionCategory/${id}`, values);
    return data;
}

export const permissionCategoryList = async () => {
    const { data } = await client.get(`Permission/GetPermissionWithCategoryList`);
    return data;
}

// Role
export const roles = async (values) => {
    const { data } = await client.post(`Role/RoleList`, values);
    return data;
}

export const role = async (id) => {
    const { data } = await client.get(`Role/GetRoleItem/${id}`);
    return data;
}

export const createRole = async (values) => {
    const { data } = await client.post(`Role/AddRole`, values);
    return data;
}

export const deleteRole = async (id) => {
    const { data } = await client.delete(`Role/RemoveRole/${id}`);
    return data;
}

export const updateRole = async (id, values) => {
    const { data } = await client.patch(`Role/EditRole/${id}`, values);
    return data;
}

export const updateRolePermission = async (values) => {
    const { data } = await client.patch(`Role/UpdateRolePermission`, values);
    return data;
}

//permission
export const permissions = async (values) => {
    const { data } = await client.post(`Permission/PermissionList`, values);
    return data;
}

export const permission = async (id) => {
    const { data } = await client.get(`Permission/GetPermissionItem/${id}`);
    return data;
}

export const createPermission = async (values) => {
    const { data } = await client.post(`Permission/AddPermission`, values)
    return data;
}

export const deletePermission = async (id) => {
    const { data } = await client.delete(`Permission/RemovePermission/${id}`);
    return data;
}

export const updatePermission = async (id, values) => {
    const { data } = await client.patch(`Permission/EditPermission/${id}`, values);
    return data;
}

export const sampleCards = async (values) => {
    const { data } = await client.post(`SampleCard/SampleCardList`, values);
    return data;
}
export const giftSampleCards = async (values, id) => {
    const { data } = await client.post(`SampleCard/GetGiftCardList/${id}`, values);
    return data;
}
export const allGiftSampleCards = async () => {
    const { data } = await client.post(`SampleCard/GetAllGiftCardList/`);
    return data;
}
export const allSampleCards = async () => {
    const { data } = await client.post(`SampleCard/GetAllCardList/`);
    return data;
}
export const createGiftSampleCard = async (values) => {
    const { data } = await client.post(`SampleCard/AddGiftCard`, values);
    return data;
}

export const sampleCardInfo = async () => {
    const { data } = await client.get(`SampleCard/SampleCardInfo`);
    return data;
}
export const sampleCard = async (id) => {
    const { data } = await client.get(`SampleCard/SampleCardItem/${id}`);
    return data;
}
export const deleteSampleCard = async (id) => {
    const { data } = await client.delete(`SampleCard/RemoveSampleCard/${id}`);
    return data;
}
export const updateCardPrice = async (id) => {
    const { data } = await client.get(`Card/UpdateCardPrice/${id}`);
    return data;
}
export const deleteSampleCardGift = async (id) => {
    const { data } = await client.delete(`SampleCard/RemoveGiftCard/${id}`);
    return data;
}
export const createSampleCard = async (values) => {
    const { data } = await client.post(`SampleCard/AddSampleCard`, values);
    return data;
}
export const updateSampleCard = async (id, values) => {
    const { data } = await client.patch(`SampleCard/EditSampleCard/${id}`, values);
    return data;
}
export const sampleCartCategories = async (values) => {
    const { data } = await client.post(`SampleCardCategory/SampleCardCategoryList`, values);
    return data;
}
export const sampleCartCategory = async (id) => {
    const { data } = await client.get(`SampleCardCategory/SampleCardCategoryItem/${id}`);
    return data;
}
export const deleteSampleCartCategory = async (id) => {
    const { data } = await client.delete(`SampleCardCategory/RemoveSampleCardCategory/${id}`);
    return data;
}
export const createSampleCardCategory = async (values) => {
    const { data } = await client.post(`SampleCardCategory/AddSampleCardCategory`, values);
    return data;
}
export const updateSampleCardCategory = async (id, values) => {
    const { data } = await client.patch(`SampleCardCategory/EditSampleCardCategory/${id}`, values);
    return data;
}

//company

export const sampleCartCompanies = async (values) => {
    const { data } = await client.post(`SampleCardCompany/SampleCardCompanyList`, values);
    return data;
}
export const sampleCartCompany = async (id) => {
    const { data } = await client.get(`SampleCardCompany/SampleCardCompanyItem/${id}`);
    return data;
}
export const deleteSampleCartCompany = async (id) => {
    const { data } = await client.delete(`SampleCardCompany/RemoveSampleCardCompany/${id}`);
    return data;
}
export const createSampleCardCompany = async (values) => {
    const { data } = await client.post(`SampleCardCompany/AddSampleCardCompany`, values);
    return data;
}
export const updateSampleCardCompany = async (id, values) => {
    const { data } = await client.patch(`SampleCardCompany/EditSampleCardCompany/${id}`, values);
    return data;
}
export const allCompany = async () => {
    const { data } = await client.get(`SampleCardCompany/GetAllSampleCardCompanyList`);
    return data;
}
//userJob

export const userJobs = async (values) => {
    const { data } = await client.post(`UserJob/UserJobList`, values);
    return data;
}
export const userJob = async (id) => {
    const { data } = await client.get(`UserJob/UserJobItem/${id}`);
    return data;
}
export const deleteUserJob = async (id) => {
    const { data } = await client.delete(`UserJob/RemoveUserJob/${id}`);
    return data;
}
export const createUserJob = async (values) => {
    const { data } = await client.post(`UserJob/AddUserJob`, values);
    return data;
}
export const updateUserJob = async (id, values) => {
    const { data } = await client.patch(`UserJob/EditUserJob/${id}`, values);
    return data;
}
export const userJobAllItemList = async () => {
    const { data } = await client.get(`UserJob/UserJobAllItemList`);
    return data;
}

//City

export const cities = async (values) => {
    const { data } = await client.post(`City/CityList`, values);
    return data;
}
export const allCities = async () => {
    const { data } = await client.get(`City/AllCityList`);
    return data;
}
export const city = async (id) => {
    const { data } = await client.get(`City/CityItem/${id}`);
    return data;
}
export const deleteCity = async (id) => {
    const { data } = await client.delete(`City/RemoveCity/${id}`);
    return data;
}
export const createCity = async (values) => {
    const { data } = await client.post(`City/AddCity`, values);
    return data;
}
export const updateCity = async (id, values) => {
    const { data } = await client.patch(`City/EditCity/${id}`, values);
    return data;
}

//CancelCause

export const cancelCauses = async (values) => {
    const { data } = await client.post(`CancelCause/CancelCauseList`, values);
    return data;
}
export const cancelCause = async (id) => {
    const { data } = await client.get(`CancelCause/CancelCauseItem/${id}`);
    return data;
}
export const deleteCancelCause = async (id) => {
    const { data } = await client.delete(`CancelCause/RemoveCancelCause/${id}`);
    return data;
}
export const createCancelCause = async (values) => {
    const { data } = await client.post(`CancelCause/AddCancelCause`, values);
    return data;
}
export const updateCancelCause = async (id, values) => {
    const { data } = await client.patch(`CancelCause/EditCancelCause/${id}`, values);
    return data;
}

//SaleStatus
export const saleStatuses = async (values) => {
    const { data } = await client.post(`SaleStatus/SaleStatusList`, values);
    return data;
}
export const saleStatus = async (id) => {
    const { data } = await client.get(`SaleStatus/SaleStatusItem/${id}`);
    return data;
}
export const deleteSaleStatus = async (id) => {
    const { data } = await client.delete(`SaleStatus/RemoveSaleStatus/${id}`);
    return data;
}
export const createSaleStatus = async (values) => {
    const { data } = await client.post(`SaleStatus/AddSaleStatus`, values);
    return data;
}
export const updateSaleStatus = async (id, values) => {
    const { data } = await client.patch(`SaleStatus/EditSaleStatus/${id}`, values);
    return data;
}

//District

export const districts = async (values) => {
    const { data } = await client.post(`District/DistrictList`, values);
    return data;
}
export const district = async (id) => {
    const { data } = await client.get(`District/DistrictItem/${id}`);
    return data;
}
export const deleteDistrict = async (id) => {
    const { data } = await client.delete(`District/RemoveDistrict/${id}`);
    return data;
}
export const createDistrict = async (values) => {
    const { data } = await client.post(`District/AddDistrict`, values);
    return data;
}
export const updateDistrict = async (id, values) => {
    const { data } = await client.patch(`District/EditDistrict/${id}`, values);
    return data;
}
export const districtListByCityId = async (id) => {
    const { data } = await client.get(`District/DistrictListByCityId/${id}`);
    return data;
}
export const updateSupplierDistrict = async (values) => {
    const { data } = await client.post(`SupplierAccessRegion/AddSupplierDistrict`, values);
    return data;
}
export const GetSupplierDistrictItem = async (id) => {
    const { data } = await client.get(`SupplierAccessRegion/GetSupplierDistricItem/${id}`);
    return data;
}
export const supplierList = async (values) => {
    const { data } = await client.post(`User/SupplierList`, values);
    return data;
}
export const UpdateCardSupplier = async (values) => {
    const { data } = await client.post(`card/AddRangeCardToSupplier`, values);
    return data;
}

export const RejectRangeNumberCard = async (values) => {
    const { data } = await client.post(`card/RejectRangeNumberCard`, values);
    return data;
}

export const GetSupplierAllTypesOfCardsForAdmin = async (id) => {
    const { data } = await client.get(`UserReport/GetSupplierAllTypesOfCardsForAdmin/${id}`);
    return data;
}
export const AddCardItemToSupplier = async (values) => {
    const { data } = await client.post(`card/AddCardItemToSupplier`, values);
    return data;
}
export const ChangeTowCardNumberData = async (values) => {
    const { data } = await client.post(`card/ChangeTowCardNumber`, values);
    return data;
}


export const AddNumberCardToBasket = async (values) => {
    const { data } = await client.post(`Basket/AddNumberCardToBasket`, values);
    return data;
}
export const AddNumberCardToBasketWithAdmin = async (values) => {
    const { data } = await client.post(`Basket/AddNumberCardToBasketWithAdmin`, values);
    return data;
}
export const RejectCardItemFromSupplier = async (values) => {
    const { data } = await client.post(`card/RejectCardItemFromSupplier`, values);
    return data;
}
//Street

export const streets = async (values) => {
    const { data } = await client.post(`Street/StreetList`, values);
    return data;
}
export const street = async (id) => {
    const { data } = await client.get(`Street/StreetItem/${id}`);
    return data;
}
export const deleteStreet = async (id) => {
    const { data } = await client.delete(`Street/RemoveStreet/${id}`);
    return data;
}
export const createStreet = async (values) => {
    const { data } = await client.post(`Street/AddStreet`, values);
    return data;
}
export const updateStreet = async (id, values) => {
    const { data } = await client.patch(`Street/EditStreet/${id}`, values);
    return data;
}
//CallStatus

export const callStatuses = async (values) => {
    const { data } = await client.post(`CallStatus/CallStatusList`, values);
    return data;
}
export const callStatus = async (id) => {
    const { data } = await client.get(`CallStatus/CallStatusItem/${id}`);
    return data;
}
export const deleteCallStatus = async (id) => {
    const { data } = await client.delete(`CallStatus/RemoveCallStatus/${id}`);
    return data;
}
export const createCallStatus = async (values) => {
    const { data } = await client.post(`CallStatus/AddCallStatus`, values);
    return data;
}
export const updateCallStatus = async (id, values) => {
    const { data } = await client.patch(`CallStatus/EditCallStatus/${id}`, values);
    return data;
}
//UserCategory

export const userCategories = async (values) => {
    const { data } = await client.post(`UserCategory/UserCategoryList`, values);
    return data;
}
export const allUserCategories = async () => {
    const { data } = await client.post(`UserCategory/AllUserCategoryList`);
    return data;
}
export const userCategory = async (id) => {
    const { data } = await client.get(`UserCategory/UserCategoryItem/${id}`);
    return data;
}
export const deleteUserCategory = async (id) => {
    const { data } = await client.delete(`UserCategory/RemoveUserCategory/${id}`);
    return data;
}
export const ChangeCategoryUserActivation = async (id) => {
    const { data } = await client.patch(`UserCategory/ChangeCategoryUserActivation/${id}`);
    return data;
}
export const createUserCategory = async (values) => {
    const { data } = await client.post(`UserCategory/AddUserCategory`, values);
    return data;
}
export const updateUserCategory = async (id, values) => {
    const { data } = await client.patch(`UserCategory/EditUserCategory/${id}`, values);
    return data;
}
export const activeUserCategories = async () => {
    const { data } = await client.get(`UserCategory/ActiveUserCategoryList`);
    return data;
}
export const GetActiveUserPolicyCategoryList = async () => {
    const { data } = await client.get(`SalePolicyFiltering/GetActiveUserPolicyCategoryList`);
    return data;
}
//City

export const userSatisfactions = async (values) => {
    const { data } = await client.post(`UserSatisfaction/UserSatisfactionList`, values);
    return data;
}
export const userSatisfaction = async (id) => {
    const { data } = await client.get(`UserSatisfaction/UserSatisfactionItem/${id}`);
    return data;
}
export const deleteUserSatisfaction = async (id) => {
    const { data } = await client.delete(`City/RemoveUserSatisfaction/${id}`);
    return data;
}
export const createUserSatisfaction = async (values) => {
    const { data } = await client.post(`UserSatisfaction/AddUserSatisfaction`, values);
    return data;
}
export const updateUserSatisfaction = async (id, values) => {
    const { data } = await client.patch(`UserSatisfaction/EditUserSatisfaction/${id}`, values);
    return data;
}
export const AllUserSatisfactionList = async () => {
    const { data } = await client.post(`UserSatisfaction/AllUserSatisfactionList/`);
    return data;
}
export const randomUserItem = async (id) => {
    const { data } = await client.get(`User/RandomUserItem/${id}`);
    return data;
}
export const dynamicRandomUserItem = async (id) => {
    const { data } = await client.get(`SalePolicyFiltering/RandomUserItem/${id}`);
    return data;
}

//childern

export const updateNumberChild = async (id, values) => {
    const { data } = await client.patch(`Child/EditNumberChild/${id}`, values);
    return data;
}
export const addUserLogStatus = async (values) => {
    const { data } = await client.post(`Sale/AddUserLogStatus`, values);
    return data;
}


export const userChildren = async (values) => {
    const { data } = await client.post(`Child/UserChildList`, values);
    return data;
}
export const userChild = async (id) => {
    const { data } = await client.get(`Child/UserChildItem/${id}`);
    return data;
}
export const deleteUserChild = async (id) => {
    const { data } = await client.delete(`Child/RemoveChild/${id}`);
    return data;
}
export const createUserChild = async (values) => {
    const { data } = await client.post(`Child/AddChild`, values);
    return data;
}
export const updateUserChild = async (id, values) => {
    const { data } = await client.patch(`Child/EditChild/${id}`, values);
    return data;

}
export const userChildrenByMarketer = async (values) => {
    const { data } = await client.post(`Child/UserChildListByMarketer`, values);
    return data;
}

export const createUserChildByMarketer = async (values) => {
    const { data } = await client.post(`Child/AddChildByMarketer`, values);
    return data;
}
export const updateUserChildByMarketer = async (id, values) => {
    const { data } = await client.patch(`Child/EditChildByMarketer/${id}`, values);
    return data;
}
export const userChildByMarketer = async (id) => {
    const { data } = await client.get(`Child/UserChildItemByMarketer/${id}`);
    return data;
}

//FollowUpUser

export const AddFollowUpUser = async (values) => {
    const { data } = await client.post(`FollowUpUser/AddFollowUpUser`, values);
    return data;
}
export const addMobileToFollowUpList = async (values) => {
    const { data } = await client.post(`FollowUpUser/AddMobileToFollowUpList`, values);
    return data;
}
export const userFollowUps = async (values) => {
    const { data } = await client.post(`FollowUpUser/UserFollowUpList`, values);
    return data;
}
export const removeFollowUpUser = async (id) => {
    const { data } = await client.delete(`FollowUpUser/RemoveFollowUpUser/${id}`)
    return data;
}

export const callHistoryDetail = async (id) => {
    const { data } = await client.get(`sale/GetDetailSaleService/${id}`)
    return data;
}

//userAddress

export const userAddresses = async (values) => {
    const { data } = await client.post(`UserAddress/UserAddressList`, values);
    return data;
}
export const getUserAddress = async (id) => {
    const { data } = await client.get(`UserAddress/UserAddressItem/${id}`);
    return data;
}
export const deleteUserAddress = async (id) => {
    const { data } = await client.delete(`UserAddress/RemoveUserAddress/${id}`);
    return data;
}
export const createUserAddress = async (values) => {
    const { data } = await client.post(`UserAddress/AddUserAddress`, values);
    return data;
}
export const SearchStreenInDistrictList = async (value) => {
    const { data } = await client.get(`UserAddress/SearchStreenInDistrictList/${value}`);
    return data;
}
export const updateUserAddress = async (id, values) => {
    const { data } = await client.patch(`UserAddress/EditUserAddress/${id}`, values);
    return data;
}
export const EditUserAddressByMarketer = async (values) => {
    const { data } = await client.patch(`UserAddress/EditUserAddressByMarketer`, values);
    return data;
}
export const updateUserMarketer = async (id, values) => {
    const { data } = await client.patch(`User/EditUserMarketer/${id}`, values);
    return data;
}
export const UpdateUserNameInfo = async (values) => {
    const { data } = await client.patch(`User/UpdateUserNameInfo`, values);
    return data;
}
export const getAllCities = async () => {
    const { data } = await client.post(`UserAddress/GetAllCities`);
    return data;
}
export const getAllDistrict = async () => {
    const { data } = await client.post(`UserAddress/GetAllDistrict`);
    return data;
}
export const getDistrictOfCity = async (id) => {
    const { data } = await client.get(`UserAddress/DistrictOfCityList/${id}`);
    return data;
}
export const getStreetOfDistrict = async (id) => {
    const { data } = await client.get(`UserAddress/StreetOfDistrictList/${id}`);
    return data;
}

//Report

export const GetRejectBasketSupplier = async (values) => {
    const { data } = await client.post(`UserReport/GetRejectBasketSupplier`, values);
    return data;
}

export const userActivityReport = async (values) => {
    const { data } = await client.post(`UserReport/UserActivityReport`, values);
    return data;
}
export const userBlockReport = async (values) => {
    const { data } = await client.post(`UserReport/CallStatusBlockList`, values);
    return data;
}
export const marketerActivityReport = async (values) => {
    const { data } = await client.post(`UserReport/MarketerActivityReport`, values);
    return data;
}
export const GetSupplierAddressDeliveryList = async (values) => {
    const { data } = await client.post(`UserReport/GetSupplierDetailForHimSelf`, values);
    return data;
}

export const GetDetailSaleForSupplier = async (values) => {
    const { data } = await client.post(`UserReport/GetDetailSaleForSupplier`, values);
    return data;
}
export const GetSupplierAvailableCardList = async (values) => {
    const { data } = await client.post(`UserReport/GetRemainingCardsSupplierList`, values);
    return data;
}
export const getUserBlockList = async (valuse) => {
    const { data } = await client.post(`UserReport/GetUserBlockList`, valuse);
    return data;
}

export const GetCustomerPurchaseHistory = async (valuse) => {
    const { data } = await client.post(`UserReport/GetCustomerPurchaseHistory`, valuse);
    return data;
}
export const GetCustomerPurchaseInfo = async (id) => {
    const { data } = await client.get(`UserReport/GetCustomerPurchaseInfo/${id}`);
    return data;
}

export const GetSaleReportForAccountant = async (valuse) => {
    const { data } = await client.post(`Basket/GetSaleReportForAccountant`, valuse);
    return data;
}
export const GetDetailSaleSupplierForAccountant = async (valuse) => {
    const { data } = await client.post(`UserReport/DetailSaleSupplierForAccountant`, valuse);
    return data;
}
export const GetBasketInfoForAdmin = async (id) => {
    const { data } = await client.get(`Basket/GetBasketInfoForAdmin/${id}`);
    return data;
}
export const CancelFinalizeBasket = async (id) => {
    const { data } = await client.get(`Basket/CancelFinalizeBasket/${id}`);
    return data;
}
export const GetAcceptedByAccountantBasketList = async (valuse) => {
    const { data } = await client.post(`UserReport/GetAcceptedByAccountantBasketList`, valuse);
    return data;
}
export const GetSupplierDeliveryCardPeriod = async (valuse) => {
    const { data } = await client.post(`UserReport/GetSupplierDeliveryCardPeriod`, valuse);
    return data;
}
export const DistrictBasketCountsByDetail = async (valuse) => {
    const { data } = await client.post(`UserReport/DistrictBasketCountsByDetail`, valuse);
    return data;
}
export const TotalSaleMarketerForAccountant = async (valuse) => {
    const { data } = await client.post(`UserReport/TotalSaleMarketerForAccountant`, valuse);
    return data;
}
export const RevokeCartByCasher = async (valuse) => {
    const { data } = await client.post(`UserReport/RevokeCartByCasher`, valuse);
    return data;
}
export const GetAcceptedCardsByAccountantList = async (valuse) => {
    const { data } = await client.post(`UserReport/GetAcceptedCardsByAccountantList`, valuse);
    return data;
}
export const GetTotalSalePerMarketer = async (valuse) => {
    const { data } = await client.post(`UserReport/GetTotalSalePerMarketer`, valuse);
    return data;
}
export const GetSupplierDistrictCount = async (valuse) => {
    const { data } = await client.post(`UserReport/GetSupplierDistrictCount`, valuse);
    return data;
}

export const TotalSaleMarketerForMarketer = async (valuse) => {
    const { data } = await client.post(`UserReport/TotalSaleMarketerForMarketer`, valuse);
    return data;
}
export const GetAllTypesOfCardsForAccounter = async () => {
    const { data } = await client.get(`UserReport/GetAllTypesOfCardsForAccounter`,);
    return data;
}

export const GetMarketerSaleIn30Day = async (values) => {
    const { data } = await client.post(`UserReport/GetMarketerSaleIn30Day`, values);
    return data;
}
export const GetMarketerSaleIn30DayForAccountant = async (values) => {
    const { data } = await client.post(`UserReport/GetMarketerSaleIn30DayWithOutFinilized`, values);
    return data;
}

export const GetMarketerSaleIn30DayForSaleManagement = async (values) => {
    const { data } = await client.post(`UserReport/GetMarketerSaleIn30DayForSaleManagement`, values);
    return data;
}
export const GetWebsiteSaleReport = async (values) => {
    const { data } = await client.post(`UserReport/GetWebsiteSaleReport`, values);
    return data;
}
export const GetWebsiteCardSaleReport = async (values) => {
    const { data } = await client.post(`UserReport/GetWebsiteCardSaleReport`, values);
    return data;
}
export const GetSampleCardSaleReport = async (values) => {
    const { data } = await client.post(`UserReport/GetSampleCardSaleReport`, values);
    return data;
}
export const GetAllTypesOfCardsForAccounterWithDate = async (values) => {
    const { data } = await client.post(`UserReport/GetAllTypesOfCardsForAccounterWithDate`, values);
    return data;
}


export const SupplierActivity = async () => {
    const { data } = await client.get(`UserReport/SupplierActivity`);
    return data;
}
export const GetInformationSelectedBasket = async (valuse) => {
    const { data } = await client.post(`Basket/GetInformationSelectedBasket`, valuse);
    return data;
}
export const ConfirmBasketsbyAccountants = async (valuse) => {
    const { data } = await client.post(`Basket/ConfirmBasketsbyAccountants`, valuse);
    return data;
}
export const GetTotalSaleSupplierForAccountant = async (valuse) => {
    const { data } = await client.post(`UserReport/TotalSaleSupplierForAccountant`, valuse);
    return data;
}
export const GetBasketInfoWithBasketNumber = async (id) => {
    const { data } = await client.get(`UserReport/GetBasketInfoWithBasketNumber/${id}`);
    return data;
}
export const BasketListFollowUpByMarketer = async (valuse) => {
    const { data } = await client.post(`Basket/BasketListFollowUpByMarketer`, valuse);
    return data;
}
export const GetBasketInDistrictSupplier = async (valuse) => {
    const { data } = await client.post(`Basket/TodayByDistrictList`, valuse);
    return data;
}
export const GetListBasketForConfirm = async (valuse) => {
    const { data } = await client.post(`Basket/GetListBasketForConfirm`, valuse);
    return data;
}
export const SupplierAcceptedBasketList = async (valuse) => {
    const { data } = await client.post(`Basket/GetSupplierAcceptedBasketList`, valuse);
    return data;
}
export const CountBasketsBySupplier = async (valuse) => {
    const { data } = await client.get(`Basket/CountBasketsBySupplier`, valuse);
    return data;
}
export const BasketListStatusCount = async (values) => {
    const { data } = await client.post(`Basket/BasketListStatusCount`, values);
    return data;
}
export const AcceptBySupplier = async (id) => {
    const { data } = await client.get(`Basket/AcceptBySupplier/${id}`)
    return data;
}

export const BasketPersonConfirm = async (values) => {
    const { data } = await client.post(`Basket/BasketPersonConfirm`, values)
    return data;
}

export const ChangeBasketStatusToAcceptedByMarketer = async (values) => {
    const { data } = await client.post(`Basket/ChangeBasketStatusToAcceptedByMarketer/`, values)
    return data;
}
export const RejectBasketBySupplier = async (values) => {
    const { data } = await client.post(`Basket/RejectBasketBySupplier`, values)
    return data;
}
export const RejectBasketByMarketer = async (values) => {
    const { data } = await client.post(`Basket/RejectBasketByMarketer`, values)
    return data;
}

export const ChangeBasketStatusByMarketer = async (values) => {
    const { data } = await client.post(`Basket/ChangeBasketStatusByMarketer`, values)
    return data;
}

export const changeStatusBlockUser = async (valuse) => {
    const { data } = await client.post(`UserReport/ChangeActionBlock`, valuse);
    return data;
}
export const blockMobile = async (mobile) => {
    const { data } = await client.get(`UserReport/BlockByMobile/${mobile}`);
    return data;
}
export const createUserByMarketer = async (values) => {
    const { data } = await client.post(`User/CustomerInfoWithMobile`, values)
    return data;
}

export const addDateFollowUp = async (values) => {
    const { data } = await client.post(`FollowUpUser/AddDateFollowUp`, values)
    return data;
}
export const addDescriptionFollowUp = async (values) => {
    const { data } = await client.post(`FollowUpUser/AddDescriptionFollowUp`, values)
    return data;
}
export const EmptyFollowUpAndFavorite = async (values) => {
    const { data } = await client.post(`FollowUpUser/EmptyFollowUpAndFavorite`, values)
    return data;
}

//cardPack
export const GetCardPackList = async (values) => {
    const { data } = await client.post(`Card/GetCardPackList`, values);
    return data;
}
export const getCardPackItem = async (id) => {
    const { data } = await client.get(`Card/GetCardPackItem/${id}`);
    return data;
}
export const cardPackUpdate = async (id, values) => {
    const { data } = await client.patch(`Card/EditCardPack/${id}`, values);
    return data;
}
export const acceptPackCard = async (id) => {
    const { data } = await client.get(`Card/AddCard/${id}`);
    return data;
}

export const GetCardSupplierList = async (values) => {
    const { data } = await client.post(`Card/GetCardSupplierList`, values);
    return data;
}
export const GetCardCurrentSupplierList = async (values) => {
    const { data } = await client.post(`Card/GetCardCurrentSupplierList`, values);
    return data;
}
export const GetSupplierAllTypesOfCards = async () => {
    const { data } = await client.get(`UserReport/GetSupplierAllTypesOfCards`);
    return data;
}
export const AddCardPack = async (values) => {
    const { data } = await client.post(`Card/AddCardPack`, values);
    return data;
}
//PaymentStatus
export const paymentStatuses = async (values) => {
    const { data } = await client.post(`PaymentStatus/PaymentStatusList`, values);
    return data;
}
export const paymentStatus = async (id) => {
    const { data } = await client.get(`PaymentStatus/PaymentStatusItem/${id}`);
    return data;
}
export const deletePaymentStatus = async (id) => {
    const { data } = await client.delete(`PaymentStatus/RemovePaymentStatus/${id}`);
    return data;
}
export const createPaymentStatus = async (values) => {
    const { data } = await client.post(`PaymentStatus/AddPaymentStatus`, values);
    return data;
}
export const updatePaymentStatus = async (id, values) => {
    const { data } = await client.patch(`PaymentStatus/EditPaymentStatus/${id}`, values);
    return data;
}
//Basket
export const BasketSendPaymentUser = async (values) => {
    const { data } = await client.post(`Basket/BasketSendPaymentUser`,values);
    return data;
}
export const UpdateBasketSendPaymentUser = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketSendPaymentUser`,values);
    return data;
}
export const CurrentBasket = async (id) => {
    const { data } = await client.get(`Basket/CurrentBasket/${id}`);
    return data;
}
export const UpdateBasketByMarketerOnline = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketByMarketerOnline`, values);
    return data;
}
export const CurrentBasketOnline = async (id) => {
    const { data } = await client.get(`Basket/CurrentBasketOnline/${id}`);
    return data;
}
export const GetBasketByIdForMarketer = async (id) => {
    const { data } = await client.get(`Basket/GetBasketByIdForMarketer/${id}`);
    return data;
}
export const GetBasketByIdForSupplier = async (id) => {
    const { data } = await client.get(`Basket/GetBasketDetailsList/${id}`);
    return data;
}
export const updateBasket = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasket`, values);
    return data;
}
export const UpdateBasketOnline = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketOnline`, values);
    return data;
}
export const updateBasketByMarketer = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketByMarketer`, values);
    return data;
}
export const updateBasketBySupplier = async (values) => {
    const { data } = await client.post(`Basket/EditBasketBySupplier`, values);
    return data;
}
export const EditBasketByAdmin = async (values) => {
    const { data } = await client.post(`Basket/EditBasketByAdmin`, values);
    return data;
}
export const updateBasketAddress = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketAddress`, values);
    return data;
}
export const UpdateBasketAddressByBasketIdForMarketer = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketAddressByBasketIdForMarketer`, values);
    return data;
}
export const updateBasketPaymentStatus = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketPaymentStatus`, values);
    return data;
}

export const CancelBasketOnlinePayment = async (values) => {
    const { data } = await client.post(`Basket/CancelBasketOnlinePayment`, values);
    return data;
}

export const UpdateBasketPaymentStatusByBasketId = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketPaymentStatusByBasketId`, values);
    return data;
}
export const UpdateBasketPaymentStatusByBasketIdByAdmin = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketPaymentStatusByBasketIdByAdmin`, values);
    return data;
}
export const UpdateBasketPaymentStatusByBasketIdByMarketer = async (values) => {
    const { data } = await client.post(`Basket/UpdateBasketPaymentStatusByBasketIdByMarketer`, values);
    return data;
}

export const BasketGetOnlineInvoiceListByMarketer = async (values) => {
    const { data } = await client.post(`Basket/GetOnlineInvoiceListByMarketer`, values);
    return data;
}


export const basketSendToSupplier = async (id, values) => {
    const { data } = await client.post(`Basket/BasketSendToSupplier/${id}`, values);
    return data;
}
export const basketSendPayment = async (id) => {
    const { data } = await client.post(`Basket/BasketSendPaymentUser/${id}`);
    return data;
}
export const EditBasketByMarker = async (id, values) => {
    const { data } = await client.post(`Basket/EditBasketByMarker/${id}`, values);
    return data;
}
export const FinalizeBasketSale = async (values) => {
    const { data } = await client.post(`Basket/FinalizeBasketSale`, values);
    return data;
}
export const CardListForBasketBySupplier = async (id) => {
    const { data } = await client.get(`Basket/CardListForBasketBySupplier/${id}`);
    return data;
}
export const BasketDetailForSupplier = async (id) => {
    const { data } = await client.get(`Basket/BasketDetailForSupplier/${id}`);
    return data;
}
export const GetCurrentBasketForAdmin = async (id) => {
    const { data } = await client.get(`Basket/GetCurrentBasketForAdmin/${id}`);
    return data;
}
export const RemoveCardFromBasketBySupplier = async (id) => {
    const { data } = await client.get(`Basket/RemoveCardFromBasketBySupplier/${id}`);
    return data;
}
export const AddRangeNumberCardToBasket = async (values) => {
    const { data } = await client.post(`Basket/AddRangeNumberCardToBasket`, values);
    return data;
}

//Reason Reject
export const reasonRejects = async (values) => {
    const { data } = await client.post(`ReasonsReject/ReasonsRejectList`, values);
    return data;
}

export const reasonReject = async (id) => {
    const { data } = await client.get(`ReasonsReject/ReasonsRejectItem/${id}`);
    return data;
}
export const deleteReasonReject = async (id) => {
    const { data } = await client.delete(`ReasonsReject/RemoveResonReject/${id}`);
    return data;
}
export const createReasonsReject = async (values) => {
    const { data } = await client.post(`ReasonsReject/AddResonReject`, values);
    return data;
}
export const updateReasonsReject = async (id, values) => {
    const { data } = await client.patch(`ReasonsReject/EditResonReject/${id}`, values);
    return data;
}
export const AllReasonsRejectList = async () => {
    const { data } = await client.get(`ReasonsReject/AllReasonsRejectList`);
    return data;
}
export const revokeCard = async (values) => {
    const { data } = await client.post(`Card/RevokeCardItemFromCashier`, values);
    return data;
}
export const CancellationListCard = async (values) => {
    const { data } = await client.post(`Card/CancellationListCard`, values);
    return data;
}
export const CardInformationForCashier = async (id) => {
    const { data } = await client.get(`Card/CardInformationForCashier/${id}`);
    return data;
}
export const cardInformation = async (id) => {
    const { data } = await client.get(`Card/InformationOfCard/${id}`);
    return data;
}
export const cardLock = async (values) => {
    const { data } = await client.post(`Card/LockCard`, values);
    return data;
}
export const cards = async (values) => {
    const { data } = await client.post(`Card/CardList`, values);
    return data;
}
export const SendRevokeCode = async (values) => {
    const { data } = await client.post(`Card/SendRevokeCode`, values);
    return data;
}
export const AcceptRevokeCode = async (values) => {
    const { data } = await client.post(`Card/AcceptRevokeCode`, values);
    return data;
}
export const AcceptRevokeByAdmin = async (values) => {
    const { data } = await client.post(`Card/AcceptRevokeCodeByAdmin`, values);
    return data;
}

//Bank
export const Banks = async (values) => {
    const { data } = await client.post(`Bank/BankList`, values);
    return data;
}


//SalePolicyFiltering

export const salePolicyFilteringList = async (values) => {
    const { data } = await client.post(`SalePolicyFiltering/SalePolicyFilteringList`, values);
    return data;
}
export const salePolicyFiltering = async (id) => {
    const { data } = await client.get(`SalePolicyFiltering/SalePolicyFilteringItem/${id}`);
    return data;
}
export const deleteSalePolicyFiltering = async (id) => {
    const { data } = await client.delete(`SalePolicyFiltering/RemoveSalePolicyFiltering/${id}`);
    return data;
}
export const createSalePolicyFiltering = async (values) => {
    const { data } = await client.post(`SalePolicyFiltering/AddSalePolicyFiltering`, values);
    return data;
}
export const updateSalePolicyFiltering = async (id, values) => {
    const { data } = await client.patch(`SalePolicyFiltering/EditSalePolicyFiltering/${id}`, values);
    return data;
}
export const RemoveSalePolicyFiltering = async (id) => {
    const { data } = await client.get(`SalePolicyFiltering/RemoveSalePolicyFiltering/${id}`);
    return data;
}
export const AddUserPolicyFiltering = async (id) => {
    const { data } = await client.get(`SalePolicyFiltering/UserPolicyFiltering/${id}`);
    return data;
}
export const CountUserPolicyFiltering = async (id) => {
    const { data } = await client.get(`SalePolicyFiltering/CountUserPolicyFiltering/${id}`);
    return data;
}


//GroupCity
export const groupCityList = async (values) => {
    const { data } = await client.post(`GroupCity/GetGroupCityList`, values);
    return data;
}
export const groupCityItem = async (id) => {
    const { data } = await client.get(`GroupCity/GetGroupCityItem/${id}`);
    return data;
}

export const createGroupCity = async (values) => {
    const { data } = await client.post(`GroupCity/AddGroupCity`, values);
    return data;
}
export const updateGroupCity = async (id, values) => {
    const { data } = await client.patch(`GroupCity/EditGroupCity/${id}`, values);
    return data;
}
export const removeGroupCity = async (id) => {
    const { data } = await client.get(`GroupCity/RemoveGroupCity/${id}`);
    return data;
}

export const groupAllCityList = async () => {
    const { data } = await client.get(`GroupCity/AllGroupCityList`);
    return data;
}




//GroupGameType
export const groupGameTypeList = async (values) => {
    const { data } = await client.post(`GroupGameType/GroupGameTypeServiceList`, values);
    return data;
}
export const groupGameTypeItem = async (id) => {
    const { data } = await client.get(`GroupGameType/GroupGameTypeServiceItem/${id}`);
    return data;
}

export const createGroupGameType = async (values) => {
    const { data } = await client.post(`GroupGameType/AddGroupGameType`, values);
    return data;
}
export const updateGroupGameType = async (id, values) => {
    const { data } = await client.patch(`GroupGameType/EditGroupGameType/${id}`, values);
    return data;
}
export const removeGroupGameType = async (id) => {
    const { data } = await client.get(`GroupGameType/RemoveGroupGameTypes/${id}`);
    return data;
}




//GroupSchool
export const groupSchoolList = async (values) => {
    const { data } = await client.post(`GroupSchool/GroupSchoolsServiceList`, values);
    return data;
}
export const groupSchoolItem = async (id) => {
    const { data } = await client.get(`GroupSchool/GroupSchoolsServiceItem/${id}`);
    return data;
}

export const createGroupSchool = async (values) => {
    const { data } = await client.post(`GroupSchool/AddGroupSchools`, values);
    return data;
}
export const updateGroupSchool = async (id, values) => {
    const { data } = await client.patch(`GroupSchool/EditGroupSchools/${id}`, values);
    return data;
}
export const removeGroupSchool = async (id) => {
    const { data } = await client.get(`GroupSchool/RemoveGroupSchools/${id}`);
    return data;
}

export const GetAllSchoolsList = async () => {
    const { data } = await client.post(`GroupBasket/GetAllSchoolsList`);
    return data;
}
export const GetAllGameType = async () => {
    const { data } = await client.post(`GroupBasket/GetAllGroupGameTypeServiceList`);
    return data;
}


export const GetGroupSchoolEmployeesListBySchoolAndShiftId = async (id) => {
    if (id) {
        const { data } = await client.get(`GroupBasket/GetGroupSchoolEmployeesListBySchoolAndShiftId/${id}`);
        return data;
    } else {
        return []
    }

}


//GroupBasket
export const groupBasketList = async (values) => {
    const { data } = await client.post(`GroupBasket/GroupBasketList`, values);
    return data;
}
export const FinalGroupBasketList = async (values) => {
    const { data } = await client.post(`GroupBasket/FinalGroupBasketList`, values);
    return data;
}
export const groupBasketListDaily = async (values) => {
    const { data } = await client.post(`GroupBasket/TodayGroupBaskets`, values);
    return data;
}
export const groupBasketItem = async (id) => {
    const { data } = await client.get(`GroupBasket/GroupBasketItem/${id}`);
    return data;
}

export const createGroupBasket = async (values) => {
    const { data } = await client.post(`GroupBasket/AddGroupBasket`, values);
    return data;
}
export const updateGroupBasket = async (id, values) => {
    const { data } = await client.patch(`GroupBasket/EditGroupBasket/${id}`, values);
    return data;
}
export const UpdateGroupBasketPricing = async (id, values) => {
    const { data } = await client.post(`GroupBasket/UpdateGroupBasketPricing/${id}`, values);
    return data;
}
export const removeGroupBasket = async (id) => {
    const { data } = await client.delete(`GroupBasket/RemoveGroupBaskets/${id}`);
    return data;
}
export const AddGroupSchoolEmployees = async (value) => {
    const { data } = await client.post(`GroupSchoolEmployees/AddGroupSchoolEmployees`, value);
    return data;
}
export const EditGroupSchoolEmployees = async (id, value) => {
    const { data } = await client.patch(`GroupSchoolEmployees/EditGroupSchoolEmployees/${id}`, value);
    return data;
}

export const updateGroupBasketToFinal = async (id, values) => {
    const { data } = await client.post(`GroupBasket/UpdateGroupBasketToFinal/${id}`, values);
    return data;
}

export const GroupSchoolEmployeesList = async (id, value) => {
    const { data } = await client.post(`GroupSchoolEmployees/GroupSchoolEmployeesList/${id}`, value);
    return data;
}

export const GroupSchoolEmployeesListAll = async (value) => {
    const { data } = await client.post(`GroupSchoolEmployees/GroupSchoolEmployeesListAll`, value);
    return data;
}

export const GroupBasketInDate = async (value) => {
    const { data } = await client.post(`GroupBasket/GroupBasketInDate`, value);
    return data;
}
export const GroupBasketMarketers = async () => {
    const { data } = await client.get(`GroupBasket/GroupBasketMarketers`);
    return data;
}
